module.exports = __webpack_public_path__ + "assets/bdc3d192e8eaf8425511946215219349.mp3";